import { Pipette, Palette, Contrast, Layers } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { ColorConverter } from './ColorConverter';
import { PaletteGenerator } from './PaletteGenerator';
import { ContrastChecker } from './ContrastChecker';
import { GradientBuilder } from './GradientBuilder';

export const colorTools: Tool[] = [
  {
    id: 'color-picker',
    name: 'Color picker & converter',
    category: 'color',
    description: 'Pick a color and convert to HEX, RGB, HSL, CSS, Tailwind.',
    keywords: ['color', 'hex', 'rgb', 'hsl', 'pick', 'convert', 'css', 'tailwind'],
    icon: Pipette,
    component: ColorConverter,
    inBrowser: true,
  },
  {
    id: 'palette-generator',
    name: 'Palette generator',
    category: 'color',
    description: 'Harmonized palettes — analogous, triadic, shades, tints.',
    keywords: ['palette', 'colors', 'scheme', 'harmony', 'brand', 'shades'],
    icon: Palette,
    component: PaletteGenerator,
    featured: true,
    inBrowser: true,
  },
  {
    id: 'contrast-checker',
    name: 'Contrast checker',
    category: 'color',
    description: 'WCAG AA/AAA compliance for any color combination.',
    keywords: ['contrast', 'wcag', 'accessibility', 'a11y', 'ratio'],
    icon: Contrast,
    component: ContrastChecker,
    inBrowser: true,
  },
  {
    id: 'gradient-builder',
    name: 'Gradient builder',
    category: 'color',
    description: 'Linear, radial, and conic gradients with multi-stop control.',
    keywords: ['gradient', 'linear', 'radial', 'conic', 'css'],
    icon: Layers,
    component: GradientBuilder,
    inBrowser: true,
  },
];
